import { render, staticRenderFns } from "./StandardFooter.vue?vue&type=template&id=381536a6"
import script from "./StandardFooter.vue?vue&type=script&lang=ts"
export * from "./StandardFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports